"use strict";

window.addEventListener("scroll", function () {
    if (window.pageYOffset >= 96) {
        document.querySelector("header").classList.add("fixed-header", "fade-in");
    } else {
        document.querySelector("header").classList.remove("fixed-header", "fade-in");
    }
});
